export default __webpack_public_path__ + "media/onboarding/welcome_files-a5c80e57.png";